import { Modal } from '@zendeskgarden/react-modals'
import type { PropsModal } from './interface';
import { Button } from '../../atoms/Button';

export function ModalContainer({ sendCancel, title, content, onClose, isDanger }: PropsModal) {

    return (
        <>
            <Modal
                onClose={onClose}
            >
                <Modal.Header tag="h2" isDanger={isDanger}>
                    {title}
                </Modal.Header>
                <Modal.Body>
                    {content}
                </Modal.Body>
                <Modal.Footer>
                    <Modal.FooterItem>
                        <Button
                            onClick={onClose}
                            isDanger={isDanger}
                            isBasic
                        >
                            Cancelar
                        </Button>
                    </Modal.FooterItem>
                    <Modal.FooterItem>
                        <Button
                            isDanger={isDanger}
                            isPrimary
                            onClick={sendCancel}
                        >
                            Confirmar
                        </Button>
                    </Modal.FooterItem>
                </Modal.Footer>
                <Modal.Close aria-label="Close modal" />
            </Modal>
        </>
    )
}